import React from 'react';

import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import { TOrbit } from '../../../i18n/TModules';
import { WizardEntry } from '../components/WizardFrame';
import { chooseAction, IWizardStepProps } from '../wizardModel';
import ActionTiles from './ActionTiles';

/**
 * Step 2/5 of Stamp (6778:17978), and on its pattern Quest's first task and Instant Reward's rule,
 * which the frames do not draw.
 */
const ActionStep: React.FC<IWizardStepProps> = ({ state, update, back }) => {
  const { t } = useMultiLanguageTranslation();
  const type = state.type ?? 'stamp';
  return (
    <WizardEntry
      title={t(`${TOrbit}.wizard.create.${type}`)}
      step={2}
      onBack={back}
      question={t(`${TOrbit}.wizard.action.question.${type}`)}
    >
      <ActionTiles
        selected={state.triggers[0]?.kind ?? null}
        onSelect={kind => update(current => chooseAction(current, kind))}
      />
    </WizardEntry>
  );
};

export default ActionStep;
